import Variable from '../../constants/constants.json';

const Sentry = require('@sentry/react');
const { GET_USER } = require('../Constants/user.constants');
const { createRequest } = require('../../api/client');

export const getUserInfo = () => async (dispatch) => {
    const options = {
        url: `${Variable.backendUrl}/user/getSessionInfo`,
        method: 'GET'
    };
    try {
        const data = await createRequest(options);
        if (data && data.user) {
            dispatch({
                type: GET_USER,
                data: data.user
            });
        } else {
            dispatch({
                type: GET_USER,
                data: {}
            });
        }
    } catch (error) {
        Sentry.captureException(error);
        dispatch({
            type: GET_USER,
            data: {}
        });
    }
};
